var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlickLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 506 506",
    style: {
      enableBackground: "new 0 0 506 506"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#821BB8;}\n\t.st1{fill:#D2D1D3;}\n\t.st2{fill:#FBFBFB;}\n\t.st3{fill:#5F1486;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M159.6,213.3l188.8-14.9c30.2,0,54.6,24.4,54.6,54.6v0c0,30.2-24.4,39.7-54.6,39.7l-188.8,14.9 c-30.2,0-54.6-24.4-54.6-54.6v0C105,222.8,129.4,213.3,159.6,213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121,214.4l67.5-67.5c26.9-26.9,49.4-58,66.5-92.1l0,0l12.8,12.8l0,0c42.6,42.6,42.6,111.8,0,154.4 l-69.5,69.5c-21.3,21.3-55.9,21.3-77.2,0l0,0C99.7,270.3,99.7,235.7,121,214.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387,291.6l-67.5,67.5c-26.9,26.9-49.4,58-66.5,92.1l0,0l-12.8-12.8l0,0c-42.6-42.6-42.6-111.8,0-154.4 l69.5-69.5c21.3-21.3,55.9-21.3,77.2,0l0,0C408.3,235.7,408.3,270.3,387,291.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlickLogo);
export default __webpack_public_path__ + "static/media/Slick-logo.e700780609879428790a3da380c1204c.svg";
export { ForwardRef as ReactComponent };